import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-r from-[#00B7E6] via-[#00CBDF] to-[#00DCD8] text-white py-8 px-6">
      <div className=" text-center gap-4">
        <p className="text-sm font-medium">
          © {new Date().getFullYear()} Riddle Studio. All rights reserved.
        </p>

      </div>
    </footer>
  );
};

export default Footer;
